module["exports"] = [
  "Allée, Voie",
  "Rue",
  "Avenue",
  "Boulevard",
  "Quai",
  "Passage",
  "Impasse",
  "Place"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/street_prefix.js
// module id = 618
// module chunks = 0